import React from 'react';

export default function IconArrowRight(props){
    return (
        <svg {...props} className={props.className} viewBox="0 0 18 33" enableBackground="new 0 0 18 33"><path fillRule="evenodd" d="M2.025,32.656 C1.794,32.884 1.504,32.998 1.186,32.998 C0.867,32.998 0.578,32.884 0.346,32.656 C-0.117,32.202 -0.117,31.462 0.346,31.007 L15.109,16.498 L0.346,1.988 C-0.117,1.534 -0.117,0.794 0.346,0.339 C0.810,-0.116 1.562,-0.116 2.025,0.339 L17.627,15.673 C18.090,16.128 18.090,16.869 17.627,17.322 L2.025,32.656 Z"/></svg>
    );
}